// src/components/TermsConditions.jsx
import React from 'react';
import './LegalPages.css';

function TermsConditions() {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>Terms & Conditions</h1>
                <p className="last-updated">Last Updated: April 3, 2025</p>

                <section>
                    <h2>1. Acceptance of Terms</h2>
                    <p>By accessing and using Koru AI ("website", "we", "us", "our"), you agree to be bound by these Terms & Conditions. If you disagree with any part, please do not use our website.</p>
                </section>

                <section>
                    <h2>2. Description of Service</h2>
                    <p>Koru AI provides an AI tools directory that allows users to:</p>
                    <ul>
                        <li>Browse and search for AI tools</li>
                        <li>Filter tools by category and features</li>
                        <li>Access tool information including descriptions, pricing, and links</li>
                        <li>Contact us through our contact form</li>
                    </ul>
                </section>

                <section>
                    <h2>3. Third-Party Links & Tools</h2>
                    <p>Our website contains links to third-party websites and tools. We do not:</p>
                    <ul>
                        <li>Own or operate any third-party AI tools listed</li>
                        <li>Guarantee the accuracy of third-party information</li>
                        <li>Assume responsibility for third-party content or practices</li>
                        <li>Receive commissions or affiliate payments (unless explicitly stated)</li>
                    </ul>
                    <p>Users should review the terms of third-party tools before using them.</p>
                </section>

                <section>
                    <h2>4. User Conduct</h2>
                    <p>You agree not to:</p>
                    <ul>
                        <li>Use our website for any illegal purpose</li>
                        <li>Attempt to gain unauthorized access to our systems</li>
                        <li>Use automated scripts to scrape our data</li>
                        <li>Interfere with the proper functioning of the website</li>
                        <li>Submit false or misleading information via contact forms</li>
                        <li>Use our service to harass or harm others</li>
                    </ul>
                </section>

                <section>
                    <h2>5. Intellectual Property</h2>
                    <p>All content on this website (excluding third-party tool data) is owned by Koru AI, including:</p>
                    <ul>
                        <li>Website design and code</li>
                        <li>Graphics and logos</li>
                        <li>Written content</li>
                        <li>Custom features and functionality</li>
                    </ul>
                    <p>The AI tools dataset is sourced from Kaggle and belongs to its respective data provider.</p>
                </section>

                <section>
                    <h2>6. Disclaimer of Warranties</h2>
                    <p>Our website is provided "as is" without any warranties, expressed or implied. We do not guarantee:</p>
                    <ul>
                        <li>That the website will be uninterrupted or error-free</li>
                        <li>The accuracy, reliability, or completeness of tool information</li>
                        <li>That third-party tools listed are safe, functional, or legitimate</li>
                        <li>That our website is free from viruses or harmful components</li>
                    </ul>
                </section>

                <section>
                    <h2>7. Limitation of Liability</h2>
                    <p>To the fullest extent permitted by law, Koru AI shall not be liable for:</p>
                    <ul>
                        <li>Any indirect, incidental, or consequential damages</li>
                        <li>Loss of profits, data, or business opportunities</li>
                        <li>Damages arising from use of third-party tools</li>
                        <li>Technical issues or service interruptions</li>
                    </ul>
                </section>

                <section>
                    <h2>8. Indemnification</h2>
                    <p>You agree to indemnify and hold harmless Koru AI from any claims, damages, or expenses arising from your use of our website or violation of these terms.</p>
                </section>

                <section>
                    <h2>9. Modifications to Service</h2>
                    <p>We reserve the right to:</p>
                    <ul>
                        <li>Modify or discontinue any part of our service</li>
                        <li>Update tool information as data changes</li>
                        <li>Change pricing models (if applicable in the future)</li>
                        <li>Add or remove features</li>
                    </ul>
                </section>

                <section>
                    <h2>10. Governing Law</h2>
                    <p>These terms are governed by the laws of India, without regard to conflict of law principles.</p>
                </section>

                <section>
                    <h2>11. Contact Information</h2>
                    <p>For questions about these Terms & Conditions:</p>
                    <ul>
                        <li>Email: c84289798@gmail.com</li>
                        <li>Through our <a href="/contact">Contact Form</a></li>
                    </ul>
                </section>
            </div>
        </div>
    );
}

export default TermsConditions;